import CryptoJS from "crypto-js";

export const logout = () => {
  localStorage.clear()
  sessionStorage.clear()
};

export const saveEncryptedDataToSessionStorage = (data, secretKey) => {
  try {
    const jsonData = JSON.stringify(data);
    const encryptedData = CryptoJS.AES.encrypt(jsonData, secretKey).toString();
    sessionStorage.setItem("encryptedData", encryptedData);
  } catch (error) {
    console.error("Error al encriptar y guardar los datos:", error);
  }
}

export const getDecryptedDataFromSessionStorage = (secretKey) => {
  try {
    const encryptedData = sessionStorage.getItem("encryptedData");
    
    if (!encryptedData) {
      return null;
    }

    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

    return decryptedData;
  } catch (error) {
    return null;
  }
};

export const logoutDoctor = () => {
  localStorage.clear()
  sessionStorage.clear()
};
